import router from "@/router";
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/components/common/loading";
import axios from "axios";
import { deleteObj } from "@/utils/validate.js";
import tokenManager from "../config/tokenManager";

// 引入封装好的设备指纹
import { getDeviceFingerprint } from "@/utils/deviceFingerprint";

// axios 配置
axios.defaults.timeout = 40000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const baseUrl = window.SITE_CONFIG.baseUrl;

function formartUrl(url) {
  if (url.charAt(0) == "/") {
    url = url.slice(1);
  }
  return url;
}

// 不检测登录的接口
const noCheckRes = ["auth/user/login", "cms/websiteadmin/selectnottoken"];

// ====================== 请求拦截器 ======================
axios.interceptors.request.use(
  async (config) => {
    let redirect_url = window.location.href.split("#")[1];

    // 直接调用封装好的 10 位指纹
    const deviceFp = await getDeviceFingerprint();

    // 需要登录的接口
    if (
      noCheckRes.indexOf(config.url) == -1 &&
      !config.url.includes("NotToken")
    ) {
      const token = tokenManager.getToken();
      config.headers["Device-Fingerprint"] = deviceFp;

      if (token) {
        config.headers.Authorization = "Bearer " + token;
        config.headers.urls = redirect_url;

        if (config.headers.isLoading !== false) {
          showFullScreenLoading();
        }
      }
    }

    // URL 处理
    if (config.url.indexOf("https") === -1) {
      if (baseUrl != "/local/") {
        config.url = baseUrl + formartUrl(config.url);
      } else {
        config.url = `/static/data/${config.url.replace(".do", "")}.json`;
        config.method = "get";
      }
    }

    // POST 参数清理
    if (config.method === "post") {
      config.data = deleteObj(config.data);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    tryHideFullScreenLoading();
    if (res.data.code === 20002) {
      // router.push("/login");
    } else if (res.data.code === 20003) {
      // router.push('/401');
    }
    return res.data;
  },
  (error) => {
    tryHideFullScreenLoading();
    return Promise.reject(error);
  },
);

export default axios;
